<template>
  <div class="u-center flex-col w-[257px] h-[325px] bg-tr text-white base p-6">
    <div class="mb-4">
      <p>İşte {{ gameName === 'emojile' ? "Emojile'de" : "Bilpop'da" }}</p>
      <p class="text-[#FFC107] text-30 font-extrabold tracking-tight leading-36 w-[197px]">Günün ilk 3’ü!</p>
    </div>
    <div class="h-[162px]">
      <a
        v-for="(user, index) in players"
        :key="index"
        :href="`/profil/${user.player.username}`"
        class="flex bg-transparent w-[209px] py-2 px-3 h-12 mb-[6px] items-center border-2 rounded-md border-[#ffffff1a]"
      >
        <OIcon v-if="user.rank === 1" icon="firstPlayer" class="w-8 h-8" />
        <OIcon v-if="user.rank === 2" icon="secondPlayer" class="w-8 h-8" />
        <OIcon v-if="user.rank === 3" icon="thirdPlayer" class="w-8 h-8" />
        <OImage :src="user.player.avatar.resolutions.standard.url" class="w-8 h-8 rounded-full mx-2 object-cover" />
        <p class="truncate text-[#FAF6F6] text-13 font-medium leading-20">{{ user.player.username }}</p>
      </a>
    </div>
    <OButton pure class="u-center bg-white px-2 py-4 mt-2 h-11 rounded-lg w-full" :href="`oyun/leaderboard/${gameName}`">
      <p class="text-13" :class="{ 'text-[#121C68]': gameName === 'emojile', 'text-[#44097C]': gameName === 'bilpop' }">
        Liderlik Tablosunu Gör
      </p>
      <ORawIcon icon="right" :svg-class="gameName === 'emojile' ? 'fill-[#121C68]' : 'fill-[#44097C]'" />
    </OButton>
  </div>
</template>
<script>
import { defineComponent, useContext, ssrRef, useAsync } from '@nuxtjs/composition-api';
import { OButton, OImage, OIcon, ORawIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OButton, OImage, OIcon, ORawIcon },
  props: {
    gameName: String,
  },
  setup(props) {
    const players = ssrRef({});
    const { $service } = useContext();
    const getLeaderboard = async () => {
      try {
        const userParams = { boardType: props.gameName, duration: 'daily', limit: 3 };
        const { data } = await $service.game.getLeaderboard(userParams);
        players.value = data;
      } catch (err) {
        console.log(err);
      }
    };

    useAsync(async () => {
      await getLeaderboard();
    });
    return { players, getLeaderboard };
  },
});
</script>
<style lang="scss" scoped>
.bg-tr {
  border-radius: 0px 12px 12px 0px;
  background: rgba(0, 0, 0, 0.15);
}
</style>
